import {
  Alert,
  Box, CircularProgress,
  Divider,
} from '@mui/material';
import { useGetSessionDetailsQuery } from '../../../../../../generated/core-api/graphql-react-query';
import SessionCompliance from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionCompliance';
import SessionDecisionTreeRuns from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionDecisionTreeRuns';
import SessionEvaluationSheets from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionEvaluationSheets';
import SessionInfo from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionInfo';
import SessionNote from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionNote';
import SessionQuality from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionQuality';
import SessionScore from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionScore';
import SessionSummary from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SessionSummary';
import SummaryDisplay from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SummaryDisplay';
import SummaryRequestContent from '../../../../../Components/MainWindow/Components/Pages/SessionsPage/Components/SessionDetailsPage/Components/SummaryRequestContent';
import Layout from './Layout';

interface EndSessionDialogProps {
  open: string | null;
  onClose: () => void;
}

export default function EndSessionDialog(props: EndSessionDialogProps) {
  const { open: sessionId, onClose } = props;
  const session = useGetSessionDetailsQuery({ input: { id: sessionId ?? '' } }, { enabled: !!sessionId });
  if (session.isLoading) {
    return (
      <Layout onClose={onClose} sessionId={sessionId}>
        <CircularProgress />
      </Layout>
    );
  }

  if (session.isError) {
    return (
      <Layout onClose={onClose} sessionId={sessionId}>
        <Alert severity="error">{(session.error as Error).message}</Alert>
      </Layout>
    );
  }

  if (!session.data) { return null; }
  const sessionDetails = session.data.getSession;

  return (
    <Layout sessionId={sessionId} onClose={onClose}>
      <SessionInfo session={sessionDetails} />
      <Box className="info">
        <SessionScore session={sessionDetails} />
        <SessionSummary session={sessionDetails} />
        <SessionNote session={sessionDetails} />
        <SummaryDisplay displays={sessionDetails.displays ?? []} />
        <SessionCompliance session={sessionDetails} />
        <SessionQuality session={sessionDetails} />
        <SessionEvaluationSheets session={sessionDetails} />
        <SessionDecisionTreeRuns session={sessionDetails} />
      </Box>
      <Divider />
      <SummaryRequestContent />
    </Layout>

  );
}
